import { useState } from "react";
import servicosSetor from "../../servicos/servicos-setor";
import MenuLateral from "./MenuLateral";
import NavMenu from "./Nav";
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Salvar from "../../img/svgs/Salvar";

const dadosSetor = {
    'nome_setor': ''
}

const CadastroSetor = () => {
    const [data, setData] = useState(dadosSetor);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const clearData = () => {
        const nome = document.querySelector('#nome_setor');
        nome.value = '';
    }
    const handleChange = (e) => {
        let { name, value } = e.target;
        setData({ ...data, [name]: value });
    }

    const criarSetor = () => {
        servicosSetor.create(data)
            .then(response => {
                if (response.status === 201) {
                    toast.success("Setor cadastrado com sucesso!", {
                        theme: "colored",
                    });
                    clearData();
                }
            })
            .catch(e => {
                toast.error("Não foi possível cadastrar o Setor!", {
                    theme: "colored"
                });
                console.log(e);
            })
    }

    return <>
        <NavMenu />
        <ToastContainer />

        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="w-75 mt-4">
                <form className="cadastros" onSubmit={handleSubmit(criarSetor)}>
                    <Form.Group className="mb-3" controlId="nome_setor">
                        <Form.Label className="label-texto">Setor</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="text"
                            name="nome_setor"
                            {...register("nome_setor", { required: true, minLength: 2 })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.nome_setor && <p className="errosValidacao">Requerido mínimo 2 letras</p>}

                    <button type="submit" className="btn-icones rounded p-1"><Salvar /> Salvar</button>
                </form>
            </div>
        </div>
    </>
}

export default CadastroSetor;